export const skillsData = [
  {
    label: "jako lider/współlider",
    data: [
      {
        skillName: "Music for K (1970)",
        percentage: "90",
      },
      {
        skillName: "Tomasz Stańko & Adam Makowicz Unit (1975)",
        percentage: "85",
      },
      {
        skillName: "Music from Taj Mahal and Karla Caves (1980)",
        percentage: "89",
      },
      {
        skillName: "The Montreux Performance lub Switzerland (1988)",
        percentage: "50",
      },
      {
        skillName: "Tales for a Girl, 12, and a Shaky Chica (1991)",
        percentage: "40",
      },
      {
        skillName: "Egzekutor (muzyka do filmu Egzekutor) (2001)",
        percentage: "60",
      },
      {
        skillName: "Lontano (2006)",
        percentage: "70",
      },
      {
        skillName: "Wisława (2013)",
        percentage: "85",
      },
    ],
  },
  {
    label: "z Komedą",
    data: [
      {
        skillName: "Astigmatic (1966)",
        percentage: "70",
      },
      {
        skillName:
          "Meine süsse Europäische Heimat: Dichtung & Jazz aus Polen (1967)",
        percentage: "65",
      },
    ],
  },
  {
    label: "z udziałem Stańki",
    data: [
      {
        skillName: "The Andrzej Trzaskowski Quintet Polish Jazz	(1965)",
        percentage: "70",
      },
      {
        skillName: "Kunstkopfindianer (1974)",
        percentage: "65",
      },
      {
        skillName: "We'll Remember Zbiggy (1979)",
        percentage: "35",
      },
      {
        skillName: "Drums Dream (1976)",
        percentage: "25",
      },
      {
        skillName: "Elżbieta Adamiak (1980)",
        percentage: "55",
      },
      {
        skillName: "Grand Standard Orchestra (1982)",
        percentage: "45",
      },
      {
        skillName: "Blues Forever (2007)",
        percentage: "45",
      },
    ],
  },
];
